var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center","justify":"center"}},[_c('v-container',{staticStyle:{"width":"320px"}},[_c('v-row',[_c('v-col',{attrs:{"align":"center","justify":"center"}},[_c('span',[_vm._v(_vm._s(_vm.$t('register.verifyingEmail')))])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }